module.exports = __webpack_public_path__ + "img/pic_pop_sorry@3x.5347d882.png";